import * as React from 'react'

const IconBrandEduWhite = (props) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}
  >
    <defs>
      <path id='icon-brand-type-edu-white_svg__a' d='M0 0h21v20H0z' />
    </defs>
    <g transform='translate(2 2)' fill='none' fillRule='evenodd'>
      <path
        d='M11.132 8.62c-.937 0-1.7.78-1.7 1.739 0 .96.763 1.74 1.7 1.74.936 0 1.698-.78 1.698-1.74 0-.959-.762-1.739-1.698-1.739m-6.096.02c-.997 0-1.807.78-1.807 1.74v.023l3.21-1.12a1.833 1.833 0 0 0-1.403-.642'
        fill='#FFF'
      />
      <mask id='icon-brand-type-edu-white_svg__b' fill='#fff'>
        <use xlinkHref='#icon-brand-type-edu-white_svg__a' />
      </mask>
      <path
        d='M20.03 10.593c-.001 1.455-1.204 2.639-2.683 2.639v-.001c-1.48 0-2.683-1.183-2.683-2.639V8.11c0-.32.257-.58.573-.58.317 0 .575.26.575.58v2.483c0 .814.688 1.475 1.534 1.475.847 0 1.537-.661 1.537-1.475v-2.48a.58.58 0 0 1 .572-.582c.317 0 .574.263.574.648v2.415zm-6.052-.234c0 1.6-1.276 2.905-2.846 2.905-1.569 0-2.846-1.304-2.846-2.905 0-1.601 1.277-2.904 2.846-2.904a2.79 2.79 0 0 1 1.698.577V5.836c0-.321.257-.582.574-.582.316 0 .574.26.574.582v4.523zm-6.182-.504a.575.575 0 0 1-.328.301l-3.825 1.331c.341.4.85.632 1.393.632.564 0 1.088-.247 1.434-.678a.566.566 0 0 1 .806-.084.59.59 0 0 1 .084.818 2.957 2.957 0 0 1-2.324 1.11c-1.63 0-2.955-1.303-2.955-2.904 0-1.603 1.325-2.905 2.955-2.905A2.96 2.96 0 0 1 7.82 9.405a.571.571 0 0 1-.024.45zM10.984 0H.508c-.52 0-.703.7-.25.962l.54.312 1.622.934c1.152.709.845 1.67.594 2.14a10.068 10.068 0 0 0-1.717 6.035c.19 5.165 4.315 9.381 9.404 9.607 5.624.25 10.265-4.285 10.3-9.928C21.032 4.488 16.475 0 10.983 0z'
        fill='#FFF'
        mask='url(#icon-brand-type-edu-white_svg__b)'
      />
    </g>
  </svg>
)

export default IconBrandEduWhite
